import styled from 'styled-components';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 10px 20px;
  border: solid 1px #cacacb;
  background-color: #ffffff;
`;